import React from 'react';
import { Shield } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function GuaranteeSection() {
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-330">
      <div className="max-w-2xl mx-auto" data-id="element-331">
        <FadeIn data-id="element-332">
          <div className="bg-base border-2 border-success rounded-lg p-10 md:p-16 text-center relative overflow-hidden" data-id="element-333">
            {/* Subtle green glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-success/5 blur-3xl pointer-events-none" data-id="element-334" />

            <div className="relative z-10" data-id="element-335">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-success/10 mb-8" data-id="element-336">
                <Shield className="w-8 h-8 text-success" data-id="element-337" />
              </div>

              <h2 className="font-display text-3xl font-bold text-text-primary mb-6" data-id="element-338">
                7-Day Guarantee
              </h2>

              <p className="font-body text-xl text-text-secondary leading-relaxed mb-8" data-id="element-339">
                If within 7 days you don't feel this book was worth your time —
                we'll refund your money. No questions asked.
              </p>

              <p className="font-ui text-sm font-medium tracking-wide text-success uppercase mb-10" data-id="element-340">
                We believe in what we publish. And we believe you will too.
              </p>

              <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-341">
                Try It Risk-Free &rarr;
              </Button>
              <p className="font-ui text-xs text-text-muted mt-4 tracking-wide" data-id="element-342">
                Full refund within 7 days. Zero risk.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}